import { useQuery } from '@tanstack/react-query';
import { IGetAllServiceBody, IGetAllServices } from "../../utils/types";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const useGetAllServices = ({
  type,
  page,
  createdago,
  fromdate,
  todate,
  users,
  drivers,
  status,
  limit = 10,
}: IGetAllServiceBody) =>
  useQuery({
    queryKey: ["get_all_services", type, page, createdago, fromdate, todate, users, drivers, status, limit],
    queryFn: async (): Promise<IGetAllServices> => {
      const res = await apiClient.get(ENDPOINTS.SERVICES.GET_ALL, {
        params: {
          type,
          page,
          createdago,
          fromDate: fromdate,
          toDate: todate,
          user: users,
          driver: drivers,
          limit,
          status,
        },
      });
      return res.data;
    },
    enabled: fromdate && todate ? fromdate <= todate : true,
  });
